import { Injectable } from '@angular/core';

import { Storage } from '@ionic/storage-angular';

// https://github.com/ionic-team/ionic-storage

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private _storage: Storage | null = null;

  constructor(private storage: Storage) {
    this.init();
  }

  async init() {
    // If using, define drivers here: await this.storage.defineDriver(/*...*/);
    const storage = await this.storage.create();
    this._storage = storage;
  }

  // Create and expose methods that users of this service can
  // call, for example:
  public set<T = any>(key: string, value: T): Promise<any> {
    return this._storage?.set(key, value);
  }

  public get<T = any>(key: string): Promise<T> {
    return this._storage?.get(key);
  }

  public remove(key: string): Promise<any> {
    return this._storage?.remove(key);
  }
}